module.exports = __webpack_public_path__ + "img/1309611063.b74a8f9e.jpg";